// @flow

import { SET_DEBT } from "../actions"

export default ( state: any = [], action: any ) => {
  switch ( action.type ) {
  case SET_DEBT:
    return action.response
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getDebt.jsx